"use client";

import plt_getPageListForMenu from "../libs/plt_getPageListForMenu";
import plt_getPathList from "../libs/plt_getPathList";
import { PAGE_INFO_TYPE } from "../types/globalConstantsTypes";

const useGetPageListForBreadCrumbs = (pagePath: string, pageInfo: PAGE_INFO_TYPE) => {
  // 現在のパスをブラウザで取得
  // const currentPath = decodeURIComponent(location.pathname);
  // console.log(location.pathname);

  // パスのリストを取得
  const pathList = plt_getPathList(pagePath);

  // パス(slug)とPage名を取得
  const pathListForMenu = plt_getPageListForMenu(pathList, pageInfo);

  // const pathListForMenu = plt_getPageListForMenu(["/","our-service","business-plan"], pageInfo);

  // debug code
  // console.log("pathListForMenu: " + JSON.stringify(pathListForMenu));

  return pathListForMenu;
}

export default useGetPageListForBreadCrumbs;